const DetailGrid = ({ items }) => (
  <div className="dashboard-detail-grid">
    {items.map(({ label, value }) => (
      <div key={label} className="dashboard-detail-grid__item">
        <dt>{label}</dt>
        <dd>{value ?? "—"}</dd>
      </div>
    ))}
  </div>
);

export default DetailGrid;
